import "./HomePage-style.css";
import header from "../images/header.png";
import image1 from "../images/imag1.jpg";
import user from "../images/user.png";
function HomePage() {
  return (
    <div className="HOME_PAGE">
      <div className="HEADER">
        <div className="HEADER__TXT">
          <p className="HEADER__TXT__TITLE">
            Object Detection of Smart Vehicles{" "}
          </p>
          <p className="HEADER__TXT__DESC">
            small description here or any sentence bla bla bla{" "}
          </p>
        </div>
        <div className="HEADER__IMG">
          <img src={image1} alt="" />
        </div>
      </div>
      {/************ PROJECT ************/}

      <div className="PROJECT">
        <div className="PROJECT__TITLE">PROJECT GOALS</div>

        <div className="PROJECT__CONTENT">
          <div className="PROJECT__CONTENT__EL">
            <b>GOAL</b>
            <p> here is some description with details </p>
          </div>
          <div className="PROJECT__CONTENT__EL">
            <b>GOAL</b>
            <p> here is some description with details </p>
          </div>
          <div className="PROJECT__CONTENT__EL">
            <b>GOAL</b>
            <p> here is some description with details </p>
          </div>
        </div>
      </div>
      {/************ CONTACT ************/}
      <div className="CONTACT">
        <div className="PROJECT__TITLE">CONTACT US</div>
        <div className="CONTACT_CONTENT">
          <div className="CONTACT_ABDULLAH">
            <img src={user} alt="" width="100%" />
            <h3> Abdullah Fahad AL-Nasban </h3>
          </div>
          <div className="CONTACT_ABDULLAH">
            <img src={user} alt="" width="100%" />
            <h3>Abdullah Mutahar AL-Huraiby</h3>
          </div>
        </div>
      </div>
    </div>
  );
}

export default HomePage;
